import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import List from '../List';
import { getPins } from '../../../actions';
import { Link } from 'react-router-dom';
import { flattenToAppURL } from '@plone/volto/helpers';
import { Icon } from '@plone/volto/components';
import pinnenSVG from '../../../icons/pinnen.svg';

const defaultLocations = [];

const DashboardPins = () => {
  const dispatch = useDispatch();
  const locationsWithPins =
    useSelector((state) => state?.pins?.result) || defaultLocations;

  React.useEffect(() => {
    dispatch(getPins());
  }, [dispatch]);

  const getLocationColumns = (locationsWithPins) => {
    let locationColumns = [];

    // eslint-disable-next-line array-callback-return
    locationsWithPins.map((location) => {
      locationColumns.push({
        title: location.title,
        pins: location.pins,
        columns: {
          title: {
            label: location.pins.length + ' Artikel',
            cellComponent: (entry) => {
              return (
                <div className={'location-title'}>
                  <Link to={flattenToAppURL(entry.url)}>{entry.title}</Link>
                  <Icon name={pinnenSVG} size="1.25em" />
                </div>
              );
            },
          },
        },
      });
    });

    return locationColumns;
  };

  return (
    <>
      {getLocationColumns(locationsWithPins).map((location, idx) => (
        <List
          key={idx}
          itemColumns={location.columns}
          items={location.pins}
          batched={25}
          pagination={false}
          headColor={'#40d4e3'}
          headTitle={location.title}
          sizeOptions={[1]}
          type={'Pins'}
        />
      ))}
    </>
  );
};

export default DashboardPins;
